import type { IRootModel } from 'watchtower-ui/models/Root';

export const setupHooks = (rootStore: IRootModel) => {
  console.log('Store mounted', rootStore);
  // * Hooks on store mount go here
};

export const cleanupHooks = (rootStore: IRootModel) => {
  console.log('Store unmounted', rootStore);
  // * Hooks on store unmount go here
};
